/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProcessingModals_viewer$ref: FragmentReference;
declare export opaque type ProcessingModals_viewer$fragmentType: ProcessingModals_viewer$ref;
export type ProcessingModals_viewer = {|
  +databaseId: string,
  +$refType: ProcessingModals_viewer$ref,
|};
export type ProcessingModals_viewer$data = ProcessingModals_viewer;
export type ProcessingModals_viewer$key = {
  +$data?: ProcessingModals_viewer$data,
  +$fragmentRefs: ProcessingModals_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProcessingModals_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    }
  ],
  "type": "Person",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'e47eb2bfa5bb5b0651325570efcf4ce2';

module.exports = node;
